import React, { useEffect, useState } from 'react'
import '../../assets/css/components/dashboardContainer/dashboardContainer.css';
import { Link, useLocation } from 'react-router-dom';
import api, { API_URL, siteTitle } from '../../api';
import { Analytics02Icon, Settings01Icon, ArrowDown01Icon, ArrowUp01Icon, Logout01Icon, Briefcase01Icon, Cancel01Icon, CircleIcon, DashboardSquare01Icon, Hospital01Icon, Notification02Icon, Target01Icon, UserMultiple02Icon } from 'hugeicons-react';
import { hasRole } from '../../services/userPosition';
import Cookies from 'js-cookie';
import { useGlobalData } from '../../services/GlobalDataContext';


const Dropdown = ({ options, isOpen, toggleDropdown, sidebarCollapsed, onNavigate }) => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <div className="drop-down">
            <div className="drop-down-title">
                <Link to="/hospitals/" className="title" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'flex-start', padding: '0.8rem', flex: 1 }}>
                    <Hospital01Icon size={24} />
                    {!sidebarCollapsed && <span>Hospitals</span>}
                </Link>
                <div onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleDropdown(); }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                    {isOpen ? (
                        <ArrowUp01Icon className="drop-down-icon" />
                    ) : (
                        <ArrowDown01Icon className="drop-down-icon" />
                    )}
                </div>
            </div>
            {isOpen && (
                <div className="drop-down-content">
                    {options.map((option, index) => (
                        <Link
                            key={index}
                            to={option.path}
                            className={`menu-item ${currentPath === option.path ? 'active' : ''}`}
                            onClick={onNavigate}
                        >
                            {option.icon ? (
                                <div className="initials">{option.icon}</div>
                            ) : (
                                <CircleIcon size={12} />
                            )}
                            {!sidebarCollapsed && <span>{option.name}</span>}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};


const SideBar = ({ mobileMenuOpen, setMobileMenuOpen, sidebarCollapsed }) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [path, setPath] = useState('');
    const [isSingleHospital, setIsSingleHospital] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const { hospitalsList } = useGlobalData();

    useEffect(() => {
        const fetchUserPermission = async () => {
            const userHospital = localStorage.getItem("hospital");
            const userHospitalId = localStorage.getItem("hospital_id");

            // Hospitals list is now provded by GlobalContext

            const isSingleHospitalUser = hasRole(["User", "User Editor", "Manager"]);

            if (isSingleHospitalUser) {
                setPath(`/hospitals/${userHospital}/${userHospitalId}/`);
                setIsSingleHospital(true);
            } else {
                setPath(`/`);
                setIsSingleHospital(false);
            }
        };

        fetchUserPermission();
    }, []);

    const isMobileView = () => window.innerWidth <= 800;
    const handleMenuClick = () => {
        if (isMobileView()) {
            setMobileMenuOpen(false);
        }
        setIsDropdownOpen(false);
    };

    const toggleDropdown = () => {
        const newState = !isDropdownOpen;
        setIsDropdownOpen(newState);
        localStorage.setItem('isDropdownOpen', newState);

    };

    const handleLogout = (e) => {
        if (e) e.preventDefault();
        Cookies.remove('accessToken');
        Cookies.remove('refreshToken');
        localStorage.clear();

        const redirectUrl = process.env.NODE_ENV === 'development'
            ? 'http://localhost:3000/login'
            : `${process.env.REACT_APP_DOMAIN_NAME || ''}/login`;
        window.location.href = redirectUrl;
    };


    return (
        <div className={`sidebar-logout ${mobileMenuOpen ? 'show' : 'hidden'}`}>
            <div className={`side-bar ${mobileMenuOpen ? 'show' : 'hide'} ${sidebarCollapsed ? 'collapsed' : ''}`}>
                <Link to="/" className='branding'>
                    <img src="/ch-white-logo.svg" alt="logo" />
                    <h2 className='site-title'>{siteTitle}</h2>
                </Link>

                <Cancel01Icon
                    size={32}
                    className="close-menu"
                    onClick={() => setMobileMenuOpen(false)}

                />

                <div className="menu-items">
                    <Link to={path} className={`menu-item ${currentPath === path ? 'active' : ''}`} onClick={handleMenuClick}>
                        <DashboardSquare01Icon size={24} />
                        {!sidebarCollapsed && <span> Dashboard</span>}
                    </Link>

                    <Link to="/users/" className={`menu-item ${currentPath === '/users/' ? 'active' : ''}`} onClick={handleMenuClick}>
                        <UserMultiple02Icon size={24} />
                        {!sidebarCollapsed && <span>Users</span>}
                    </Link>



                    {!isSingleHospital && (
                        <Dropdown
                            options={hospitalsList}
                            isOpen={isDropdownOpen}
                            toggleDropdown={toggleDropdown}
                            sidebarCollapsed={sidebarCollapsed}
                            onNavigate={handleMenuClick}
                        />
                    )}

                    <Link to="/measures/" className={`menu-item ${currentPath === '/measures/' ? 'active' : ''}`} onClick={handleMenuClick}>
                        <Analytics02Icon size={24} />
                        {!sidebarCollapsed && <span>Measures</span>}
                    </Link>

                    <Link to="/measure_data/" className={`menu-item ${currentPath === '/measure_data/' ? 'active' : ''}`} onClick={handleMenuClick}>
                        <Analytics02Icon size={24} />
                        {!sidebarCollapsed && <span>Measure Data</span>}
                    </Link>


                    <Link to="/positions/" className='menu-item' onClick={handleMenuClick}>
                        <Briefcase01Icon size={24} />
                        {!sidebarCollapsed && <span>Roles & Permissions</span>}
                    </Link>


                    <Link to="/targets/" className={`menu-item ${currentPath === '/targets/' ? 'active' : ''}`} onClick={handleMenuClick}>
                        <Target01Icon size={24} />
                        {!sidebarCollapsed && <span>Targets</span>}
                    </Link>

                    {
                        hasRole(["Admin", "Super User"]) &&

                        <Link to="/notifications/" className={`menu-item ${currentPath === '/notifications/' ? 'active' : ''}`} onClick={handleMenuClick}>
                            <Notification02Icon size={24} />
                            {!sidebarCollapsed && <span>Notifications</span>}
                        </Link>
                    }

                    {hasRole(["Admin", "Super User"]) && (
                        <Link to="/settings/" className={`menu-item ${currentPath === '/settings/' ? 'active' : ''}`} onClick={handleMenuClick}>
                            <Settings01Icon size={24} />
                            {!sidebarCollapsed && <span>Settings</span>}
                        </Link>
                    )}

                    <div className="profile-item" onClick={handleLogout} style={{ cursor: 'pointer' }} role="button" tabIndex="0">
                        <Logout01Icon size={24} color={"#ffffff"} variant={"stroke"} />
                        {!sidebarCollapsed && <span>Logout</span>}
                    </div>

                </div>


            </div>
        </div>
    );
};

export default SideBar;